'use strict';
var ansiRegex = require('ansi-regex')();

module.exports = function (str) {
	return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
};



//////////////////
// WEBPACK FOOTER
// (webpack)-hot-middleware/~/strip-ansi/index.js
// module id = 2693
// module chunks = 0